export enum PendingAreaInfoStatus {
    New = 1,
    Approved = 2,
    Canceled = 3
}

export enum PendingAreaDisplayStatus {
    Unbilled = 1,
    Billed = 2,
    Canceled = 3
}